<template>
  <div v-if="visible" :class="['Dialog', prefixClz]">
    <div class="Dialog__mask" @click="modalClick"></div>
    <div class="Dialog__box">
      <a href="javascript:;" v-if="showClose" @click="closeBtnClick" class="Dialog__close"></a>
      <div class="Dialog__body">
        <div class="Dialog__title">
          <slot name="title">{{ title }}</slot>
        </div>
        <div class="Dialog__content" v-if="!hideContent" :style="{ textAlign }">
          <slot></slot>
        </div>
      </div>
      <slot name="footer">
        <div class="Dialog__footer" v-if="!noOkBtn || !noCancelBtn">
          <button
            class="Dialog__btn Dialog__btn--cancel"
            v-if="!noCancelBtn"
            @click="cancelBtnClick"
            >{{ cancelBtnTxt }}</button
          >
          <button
            class="Dialog__btn Dialog__btn--ok"
            v-if="!noOkBtn"
            :class="{ disabled: okBtnDisabled }"
            :disabled="okBtnDisabled"
            @click="okBtnClick"
            >{{ okBtnTxt }}</button
          >
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import props from "./props";

let openedCount = 0;
const BODY_CLASS = "dialog-open";

const lockMaskScroll = (bodyCls => {
  let scrollTop;
  let top;
  return {
    afterOpen: function() {
      openedCount += 1;
      if (openedCount > 1) return;
      top = document.body.style.top;
      scrollTop = document.scrollingElement.scrollTop || document.body.scrollTop;
      document.body.classList.add(bodyCls);
      document.body.style.top = -scrollTop + "px";
    },
    beforeClose: function() {
      openedCount -= 1;
      if (openedCount > 0) return;
      if (document.body.classList.contains(bodyCls)) {
        document.body.classList.remove(bodyCls);
        setTimeout(() => {
          document.body.style.top = top;
          // 下面的操作会造成 reflow, 延迟到对话框关闭后进行
          document.scrollingElement.scrollTop = scrollTop;
        }, 0);
      }
    },
  };
})(BODY_CLASS);

export default {
  name: "Dialog",
  props,
  methods: {
    modalClick() {
      if (!this.maskClosable) return;
      this.close();
    },
    close() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    okBtnClick() {
      this.$emit("ok");
    },
    cancelBtnClick() {
      this.$emit("cancel");
      if (this.closeOnCancel) {
        this.close();
      }
    },
    closeBtnClick() {
      this.close();
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (this.lockBgScroll) {
          if (val) {
            lockMaskScroll.afterOpen();
          } else if (this._everOpened) {
            lockMaskScroll.beforeClose();
          }
        }

        if (this._everOpened) {
          if (!val) {
            this.$emit("closed");
          }
        }

        this._everOpened = true;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
@import "~style/tool.scss";

$primary-color: #f0250f;

$color: #666;
$title-color: #333333;
$border-radius: 4px;

$font-size-base: 14px;
$font-size-large: 16px;
$light-color: #f6f6f6;

$btn-disable-bg: #dadada;
$btn-disable-color: #f6f6f6;

body.dialog-open {
  position: fixed;
}

.fade-enter-active {
  transition: opacity 225ms ease-out;
}

.fade-leave-active {
  transition: opacity 195ms ease-in;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.Dialog__mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.Dialog__mask {
  z-index: $zindex-modal-backdrop;
  background: rgba(0, 0, 0, 0.5);
}

.Dialog__box {
  position: fixed;
  z-index: $zindex-modal;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);

  width: 72%;
  max-height: 70vh;
  background: #fff;
  color: $color;
  border-radius: $border-radius;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.Dialog__title {
  color: $title-color;
  text-align: center;
  font-size: $font-size-large;
  flex-shrink: 0;
  padding-bottom: 8px;
  @include truncateText();
}

.Dialog__close {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  font-size: 20px;
  text-align: center;
  text-decoration: none;
  background: url("data:image/svg+xml, %3Csvg width='30' height='30' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='rgb(132,132,132)' fill-rule='evenodd'%3E%3Cpath d='M.44 2.56A1.5 1.5 0 1 1 2.56.44l27 27a1.5 1.5 0 1 1-2.12 2.12L15 17.123 2.56 29.56A1.5 1.5 0 1 1 .44 27.44L12.878 15 .44 2.56zM27.44.44a1.5 1.5 0 1 1 2.12 2.12l-9 9a1.5 1.5 0 1 1-2.12-2.12l9-9z'/%3E%3C/g%3E%3C/svg%3E")
    no-repeat center;
  background-size: 13px 13px;
  img {
    height: 13px;
  }
}

.Dialog__body {
  box-sizing: border-box;
  padding: 26px 20px 20px;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
}

.Dialog__content {
  flex: 1;
  overflow: auto;
  font-size: $font-size-base;
  word-break: break-all;
  padding-bottom: 10px;
  -webkit-overflow-scrolling: touch;
}

.Dialog__footer {
  height: 40px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
  border-radius: 0 0 $border-radius $border-radius;
  align-items: center;
  overflow: hidden;
  flex-direction: row;
}

.Dialog__btn {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  flex: 1;
  font-size: $font-size-base;
  border: none;
  background: transparent;
  appearance: none;
  outline: none;
  user-select: none;
  border-top: 1px solid $light-color;
  color: $color;
  &:only-child {
    border-radius: 0 0 $border-radius $border-radius;
    color: $primary-color;
    border-top: 1px solid $light-color;
  }
  &:active {
    border-top: 1px solid #ccc;
    background: #ccc;
  }
}

.Dialog__btn + .Dialog__btn {
  border-left: 1px solid $light-color;
}

.Dialog__btn--cancel {
  border-radius: 0 0 0 $border-radius;
  background: #fff;
  background-origin: border-box;
}

.Dialog__btn--ok {
  border-radius: 0 0 $border-radius 0;
  background-origin: border-box;
  color: $primary-color;
}

.Dialog__btn.disabled {
  background: $btn-disable-bg;
  background-origin: border-box;
  color: $btn-disable-color;
  border-color: $btn-disable-bg;
}
</style>
